import { IconButton } from '@billy/design-system'
import React, { useRef, useState } from 'react'

import { useOnClickOutside } from '../../../../hooks'
import { reactClass } from '../../../../utils'
import * as Styled from './styles'

type DatePeriodChooserDropdownButtonProps = {
  disabled?: boolean
  children: React.ReactNode
}

export const DatePeriodChooserDropdownButton = (
  props: React.PropsWithChildren<DatePeriodChooserDropdownButtonProps>,
) => {
  const { disabled, children } = {
    ...props,
  }

  const [open, setOpen] = useState(false)
  const buttonRef = useRef<HTMLDivElement | null>(null)

  const handleOpen = () => {
    if (!disabled) {
      setOpen(!open)
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  useOnClickOutside(buttonRef, handleClose)

  return (
    <Styled.DatePeriodChooserButtonWrapper ref={buttonRef} className={reactClass('filter-dropdown-button')}>
      <IconButton icon="calendar" onClick={handleOpen} />
      <Styled.DatePeriodChooserWrapper open={open}>{children}</Styled.DatePeriodChooserWrapper>
    </Styled.DatePeriodChooserButtonWrapper>
  )
}
